import HTTP from '../common/http-common';

const insertCustomer = (data) => HTTP.post("/common/insert-customer/", {
    customerCode: data.customerCode,
    customerName: data.customerName,
    houseNo: data.houseNo,
    subdistrict: data.subdistrict,
    district: data.district,
    province: data.province,
    tel: data.tel,
    mobile: data.mobile,
    email: data.email,
    branchCode: data.branchCode,
    postCode: data.postCode
});

const existCustomerMobile = (mobile, branchCode) => HTTP.get("/common/exist-customer-tel", {
    params: {
        mobile: mobile,
        branchCode: branchCode
    }
});

const insertCar = (data) => HTTP.post("/common/insert-car/", {
    licenseNo: data.licenseNo,
    licenseNoProvince: data.licenseNoProvince,
    bodyNumber: data.bodyNumber,
    engineNumber: data.engineNumber,
    modelCode: data.modelCode,
    bodyType: data.bodyType,
    colorCode: data.colorCode,
    branchCode: data.branchCode,
    postCode: data.postCode,
    brandCode: data.brandCode
});

const existCar = (licenseNo, province, modelCode, branchCode) => HTTP.get("/common/exists-car", {
    params: {
        branchCode: branchCode,
        licenseNo: licenseNo,
        province: province,
        modelCode: modelCode
    }
});

export {
    insertCustomer,
    existCustomerMobile,
    insertCar,
    existCar
}